<terra-welcome-layout [showReleaseNotification]="false">
  <section class="welcome-text">Nice to meet you</section>

  <section class="welcome-sub-text">
    Stay on top of your investments with advanced reports and updates from your real estate GPs
  </section>

  <section class="form-content">    
    
    <ng-container *ngIf="{logoData: referrerLogo$ | async} as referrer">
      <img class="referrer-logo" *ngIf="referrer?.logoData?.showLogo" [src]="referrer?.logoData?.logoUrl"/>
    </ng-container>

    <!-- <a class="small-screen-logo" href="https://www.covercy.com/">
      <img src="/assets/images/logo/logo.png" alt="Covercy"/>
    </a> -->
            
    <form class="form terra-error-style" [formGroup]="registerForm" (ngSubmit)="register()">
      <h1>Sign up</h1>

      <p class="goto-login">
        Already have an account?
        <a [routerLink]="routingService.loginLpPage" class="link" queryParamsHandling="preserve"
           routerLinkActive="active">Log in</a>
      </p>

      <p class="section-header">Select your account type</p>
      <div class="select-organization">
        <span [class.selected]="registerForm.get('isOrganization').value === false"
              (click)="registerForm.get('isOrganization').setValue(false)">
          <mat-radio-button [checked]="registerForm.get('isOrganization').value === false"></mat-radio-button>
          Personal
        </span>
        <span [class.selected]="registerForm.get('isOrganization').value === true"
              (click)="registerForm.get('isOrganization').setValue(true)">
            <mat-radio-button [checked]="registerForm.get('isOrganization').value === true"></mat-radio-button>
          Business
        </span>
      </div>

      <div class="section-header">
        Sign up using your email address
      </div>
      <!-- Email address -->
      <mat-form-field appearance="outline" class="input-width">
        <input matInput placeholder="Email" formControlName="username"/>
        <mat-error *ngIf="registerForm.get('username').hasError('email')">
          Please enter a valid email address
        </mat-error>
        <mat-error *ngIf="registerForm.get('username').hasError('required')">
          Email is required
        </mat-error>
      </mat-form-field>

      <!-- Password -->
      <mat-form-field appearance="outline" class="input-width">
        <input
          [type]="showPassword ? 'text' : 'password'"
          matInput
          placeholder="Create a password"
          formControlName="password"
          maxlength="16"
          class="lo_sensitive"
        />
        <mat-icon *ngIf="!isLoading" matSuffix (click)="showPassword = !showPassword"
                  class="show-password-icon notranslate" color="primary">remove_red_eye
        </mat-icon>
        <mat-error *ngIf="registerForm.get('password').hasError('required')">
          Password is required
        </mat-error>
        <mat-error
          *ngIf="
            !registerForm.get('password').hasError('required') &&
            (registerForm.get('password').hasError('passwordstrength') || registerForm.get('password').hasError('minlength'))">
          Password should be at least 8 characters and contain at least one letter and one digit
        </mat-error>
      </mat-form-field>

      <ngx-recaptcha2 #recaptcha formControlName="recaptcha" class="recaptcha"
                      [siteKey]="appSettingsService.recaptchaPublicKey">
      </ngx-recaptcha2>
      <mat-error *ngIf="showCaptchaError && registerForm.get('recaptcha').hasError('required')" class="recaptcha-error">
        Please verify you're not a robot
      </mat-error>

      <!-- Sign up button -->
      <div class="input-width">
        <button type="submit" mat-flat-button class="tall-button" color="primary" [disabled]="isLoading">
          Sign Up
        </button>
      </div>

      <p class="error-message" *ngIf="showSubmitError">{{ error }}</p>
     
    </form>
    
    <div [ngClass]="{'social-plugins':true, 'social-plugins-blur':!(ssoLoader$ | async)}">

      <button (click)="signInWithFacebook($event)" [disabled]="!(ssoLoader$ | async)">
        <img src="/assets/images/icons/facebook-icon.svg" alt="">
        Facebook
      </button>
      <asl-google-signin-button type='standard' size='large' />

    </div>
    <terra-loader class="ssoLoader" *ngIf="!(ssoLoader$ | async)" />

    <div class="authorized-uk">
      <mat-icon class="notranslate">verified_user</mat-icon>
      Authorised by the UK FCA
    </div>

    <p class="terms-info">
      By creating an account, I agree to Covercy's
      <a href="{{termType.getUrl(termType.ClientTermsOfService)}}" class="mat-primary" target="_blank">Terms and conditions</a> and <a href="{{termType.getUrl(termType.ClientPrivacyPolicy)}}" class="mat-primary" target="_blank">Privacy Policy</a>.
    </p>
    
    <terra-loader [centerToParent]="true" *ngIf="isLoading" />

    <div class="data-safe">
      <img src="/assets/images/icons/data-safe.png"/>
    </div>
  </section>
</terra-welcome-layout>
